export const TRIGGER_OFFSET = 8
export const DEFAULT_Z_INDEX = 1055
